export default __webpack_public_path__ + "static/media/bold.ae028f32.svg";